import type { Bridge } from '../../data/generated/layout';
import type { Vec2 } from '../../geo/types';
import type { ReservedFootprint } from './types';

/* A bridge shorter than this spans no water (site/bridges.ts lays it no deck). */
const LEAST_SPAN_M = 0.01;

/**
 * PLAN Lots, bridge spans (2026-10-06): a bridge lands on its bank, not on a house. Each bridge's
 * surveyed span, bank to bank at the deck's width, is ground no house may stand on, so the lots
 * beside a bridge's head start clear of its deck.
 */
export function bridgeSpanReservations(bridges: readonly Bridge[]): ReservedFootprint[] {
  return bridges.flatMap((bridge) => {
    const [ax, ay] = bridge.a;
    const [bx, by] = bridge.b;
    const length = Math.hypot(bx - ax, by - ay);
    if (length < LEAST_SPAN_M) return [];
    const half = bridge.width / 2;
    const across: Vec2 = [(-(by - ay) / length) * half, ((bx - ax) / length) * half];
    const outer: Vec2[] = [
      [ax + across[0], ay + across[1]],
      [ax - across[0], ay - across[1]],
      [bx - across[0], by - across[1]],
      [bx + across[0], by + across[1]],
    ];
    return [{ id: `bridge-span:${bridge.id}`, polygon: { outer, holes: [] } }];
  });
}
